import { useState } from 'preact/hooks';
import useApp from '../context/AppContext';
import {useToaster} from '../context/ToasterContext';
import SubmitButton from '../components/ui/SubmitButton';
import Form from '../components/ui/Form';
import Input from '../components/ui/Input';
import { addCategory, findCategories, updateCategory } from '../api/api';

export default function FormCategory(route) {
    let name = "";
    const { categories, setCategories } = useApp();
    const addToast = useToaster();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

    if (typeof categories == 'undefined' || categories === null ) {
        return <div className="text-center pt-5">Loading categories ...</div>;
    }
    if (route.id) {
        const category = categories.find(category => parseInt(category.id) === parseInt(route.id));
        if (category) {
            name = category.name;
        }
    }

    function refreshCategories() {
        findCategories().then((categories) => { setCategories(categories) });
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formCategory = {
            name: fields.name.value,
        }
        setSubmitButtonDisabled(true);
        if (route && route.id) {
            updateCategory(formCategory, route.id).then((response) => {
                setSubmitButtonDisabled(false);
                if (response["@context"] == '/api/contexts/Error') {
                    addToast('danger', 'Erreur lors de l\'ajout de la catégorie : ' + response["hydra:description"]);
                } else if (response.code && response.code == '401') {
                    addToast('warning', 'Vous n\'avez pas les droits pour modifier la catégorie !');
                }
                else {
                    addToast('success', 'Catégorie mise à jour');
                    refreshCategories();
                    history.go(-1);
                }
            }).catch(error => {
                addToast('danger', 'Erreur lors de la mise à jour d\'une catégorie' + error);
            });
        } else {
            addCategory(formCategory).then((response) => {
                setSubmitButtonDisabled(false);
                if (response["@context"] == '/api/contexts/Error') {
                    addToast('danger', 'Erreur lors de l\'ajout de la catégorie : ' + response["hydra:description"]);
                } else if (response.code && response.code == '401') {
                    addToast('warning', 'Vous n\'avez pas les droits pour modifier la catégorie !');
                }
                else {
                    addToast('success', 'Catégorie ajouté');
                    refreshCategories();
                    history.go(-1);
                }
            }).catch(error => {
                setSubmitButtonDisabled(false);
                addToast('danger', 'Erreur lors de la création d\'une catégorie' + error);
            });
        }
    }

    return (
        <div class="container-md mt-2">
            <h1 class="text-center">Fiche catégorie (édition)</h1>
            <Form onSubmit={(handleSubmit)}>
                <Input id="name" label="Nom" type="text" value={name} />
                <SubmitButton disabled={submitButtonDisabled} />
            </Form>
        </div>
    );
}